<template>
    <!-- 分包管理 -->
    <div class="join-ent-box">
        <div class="box-head">
            <el-page-header @back="goBack" content="专户管理"></el-page-header>
            <el-button type="primary" @click="submitForm('form')">提交</el-button>
        </div>
        <div class="box-con">
            <el-form ref="form" :model="form" label-width="180px">
                <!-- 农民工专户开户证明 -->
                <el-form-item label="农民工专户开户证明：">
                    <div class="contract-photo" v-for="(item,index) in fileList1" :key="index">
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                    <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl"
                    :headers="uploadHead"
                    :data={type:237}
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="fileSuccess1"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                    </el-upload>
                </el-form-item>
                <!-- 专户到账凭证 -->
                <el-form-item label="专户到账凭证：">
                    <div class="contract-photo" v-for="(item,index) in fileList2" :key="index">
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                    <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl"
                    :headers="uploadHead"
                    :data={type:237}
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="fileSuccess2"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                    </el-upload>
                </el-form-item>
                <!-- 工资发放审核 -->
                <el-form-item label="专户到账凭证：">
                    <div class="contract-photo" v-for="(item,index) in fileList3" :key="index">
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                    <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl"
                    :headers="uploadHead"
                    :data={type:237}
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="fileSuccess3"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                    </el-upload>
                </el-form-item>
                <!-- 银行三方协议 -->
                <el-form-item label="银行三方协议：">
                    <div class="contract-photo" v-for="(item,index) in fileList4" :key="index">
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                    <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl"
                    :headers="uploadHead"
                    :data={type:237}
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="fileSuccess4"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                    </el-upload>
                </el-form-item>
                <!-- 工资流水 -->
                <el-form-item label="工资流水：">
                    <div class="contract-photo" v-for="(item,index) in fileList5" :key="index">
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                    <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl"
                    :headers="uploadHead"
                    :data={type:237}
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="fileSuccess5"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                    </el-upload>
                </el-form-item>
                <!-- 工资发放公示 -->
                <el-form-item label="工资发放公示：">
                    <div class="contract-photo" v-for="(item,index) in fileList6" :key="index">
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                    <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl"
                    :headers="uploadHead"
                    :data={type:237}
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="fileSuccess6"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                    </el-upload>
                </el-form-item>
                <!-- 保障金保函 -->
                <el-form-item label="保障金保函：">
                    <div class="contract-photo" v-for="(item,index) in fileList7" :key="index">
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                    <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl"
                    :headers="uploadHead"
                    :data={type:237}
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="fileSuccess7"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                    </el-upload>
                </el-form-item>
                <!-- 工资委托代付协议 -->
                <el-form-item label="工资委托代付协议：">
                    <div class="contract-photo" v-for="(item,index) in fileList8" :key="index">
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                    <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl"
                    :headers="uploadHead"
                    :data={type:237}
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="fileSuccess8"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                    </el-upload>
                </el-form-item>
                <!-- 农民工维权工作组成立文件 -->
                <el-form-item label="农民工维权工作组成立文件：">
                    <div class="contract-photo" v-for="(item,index) in fileList9" :key="index">
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                    <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl"
                    :headers="uploadHead"
                    :data={type:237}
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="fileSuccess9"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                    </el-upload>
                </el-form-item>
                <!-- 工程款支付担保或履约担保 -->
                <el-form-item label="工程款支付担保或履约担保：">
                    <div class="contract-photo" v-for="(item,index) in fileList10" :key="index">
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                    <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl"
                    :headers="uploadHead"
                    :data={type:237}
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="fileSuccess10"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                    </el-upload>
                </el-form-item>
                <!-- 专户拨付凭证 -->
                <el-form-item label="专户拨付凭证：">
                    <div class="contract-photo" v-for="(item,index) in fileList11" :key="index">
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                    <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl"
                    :headers="uploadHead"
                    :data={type:237}
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="fileSuccess11"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                    </el-upload>
                </el-form-item>
                <!-- 其他工程款拨付凭证 -->
                <el-form-item label="其他工程款拨付凭证：">
                    <div class="contract-photo" v-for="(item,index) in fileList12" :key="index">
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                    <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl"
                    :headers="uploadHead"
                    :data={type:237}
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="fileSuccess12"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                    </el-upload>
                </el-form-item>
                <!-- 建设单位支付给施工总承包企业工程预付款银行付款凭证 -->
                <el-form-item label="建设单位支付给施工总承包企业工程预付款银行付款凭证：">
                    <div class="contract-photo" v-for="(item,index) in fileList13" :key="index">
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                    <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl"
                    :headers="uploadHead"
                    :data={type:237}
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="fileSuccess13"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                    </el-upload>
                </el-form-item>
                <!-- 劳资专管员任命书 -->
                <el-form-item label="劳资专管员任命书：">
                    <div class="contract-photo" v-for="(item,index) in fileList14" :key="index">
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                    <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl"
                    :headers="uploadHead"
                    :data={type:237}
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="fileSuccess14"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                    </el-upload>
                </el-form-item>
                <!-- 维权信息公示牌照片 -->
                <el-form-item label="维权信息公示牌照片：">
                    <div class="contract-photo" v-for="(item,index) in fileList15" :key="index">
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                    <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl"
                    :headers="uploadHead"
                    :data={type:237}
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="fileSuccess15"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                    </el-upload>
                </el-form-item>
                <!-- 分包企业委托施工总承包企业发放工资委托书 -->
                <el-form-item label="分包企业委托施工总承包企业发放工资委托书：">
                    <div class="contract-photo" v-for="(item,index) in fileList16" :key="index">
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                    <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl"
                    :headers="uploadHead"
                    :data={type:237}
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="fileSuccess16"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                    </el-upload>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import base from '../../../untils/base'
import myHttp from '../../../untils/port';
import util from '../../../untils/util'
export default {
    data(){
        //手机号验证
        // var validatePhone = (rule, value, callback) => {
        //     if (value === '') {
        //     // callback(new Error('请输入手机号码！'));
        //     callback();
        //     } else if(!(/^1[3456789]\d{9}$/.test(value))){
        //     callback(new Error('手机号码格式错误！'));
        //     }else{
        //     callback();
        //     }
        // };
        return{
            id:'',
            groupId:'',
            // pageEnt:'',
            form:{
                projectId:'',
                workersAccount:'',  //农民工专户开户证明
                accounting:'',  //专户到账凭证
                wageAudit :'',  //工资发放审核
                bankAgreement:'',  //银行三方协议
                wageWater:'',  //工资流水
                waterNotice:'',  //工资发放公示
                cashDeposit:'',  //保证金保函
                wageAgreement:'',  //工资委托代付协议
                createBy:'',
                ruralWorkers:'',//农民工维权工作组成立文件
                bidBond:'',//工程款支付担保或履约担保
                voucher:'',//专户拨付凭证
                disbursementVoucher:'',//其他工程款拨付凭证
                constructionUnitShal:'',//建设单位支付给施工总承包企业工程预付款银行付款凭证
                letter:'',//劳资专管员任命书
                rightInformation:'',//维权信息公示牌照片
                subcontractorEntrusts:'',//分包企业委托施工总承包企业发放工资委托书
            },
            // uploadUrl:base.url+"/upload/uploadPhotosAndThumbnail",//上传地址
            uploadUrl:base.url + '/upload/uploadPhoto', //上传地址
            uploadHead:{  //上传接口header
                accessToken:util.session.get('token')
            },
            fileList1:[],
            fileList2:[],
            fileList3:[],
            fileList4:[],
            fileList5:[],
            fileList6:[],
            fileList7:[],
            fileList8:[],
            fileList9:[],
            fileList10:[],
            fileList11:[],
            fileList12:[],
            fileList13:[],
            fileList14:[],
            fileList15:[],
            fileList16:[],
        }
    },
    mounted(){
        // var params = this.$route.params
        // this.id = params.id
        this.groupId=util.session.get('groupId')
        this.getData()
        // this.getInfo()
    },
    methods:{
        //获取参建信息
        // getInfo(){
        //     var that = this
        //     myHttp.getProjectById({
        //         id:this.groupId
        //     }).then(function(resp){
        //         if(resp.data.code=='200'){
        //             that.pageEnt = resp.data.data.project.name||''
        //         }
        //     })
        // },
        //获取数据
        getData(){
            var that = this
            myHttp.getSpecialAccountByProjectId({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.proSpecialAccount
                    if(data){
                        that.form.id = data.id
                        that.fileList1 = []
                        if(data.workersAccount && ''!=data.workersAccount){
                            var lis = data.workersAccount.split(',')
                            for(var i=0;i<lis.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis[i]
                                obj.showUrl = base.httpCtx + lis[i]
                                obj.srcList = [base.httpCtx + lis[i]]
                                that.fileList1.push(obj)
                            }
                        }
                        that.fileList2 = []
                        if(data.accounting && ''!=data.accounting){
                            var lis1 = data.accounting.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList2.push(obj)
                            }
                        }
                        that.fileList3 = []
                        if(data.wageAudit && ''!=data.wageAudit){
                            var lis1 = data.wageAudit.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList3.push(obj)
                            }
                        }
                        that.fileList4 = []
                        if(data.bankAgreement && ''!=data.bankAgreement){
                            var lis1 = data.bankAgreement.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList4.push(obj)
                            }
                        }
                        that.fileList5 = []
                        if(data.wageWater && ''!=data.wageWater){
                            var lis1 = data.wageWater.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList5.push(obj)
                            }
                        }
                        that.fileList6 = []
                        if(data.waterNotice && ''!=data.waterNotice){
                            var lis1 = data.waterNotice.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList6.push(obj)
                            }
                        }
                        that.fileList7 = []
                        if(data.cashDeposit && ''!=data.cashDeposit){
                            var lis1 = data.cashDeposit.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList7.push(obj)
                            }
                        }
                        that.fileList8 = []
                        if(data.wageAgreement && ''!=data.wageAgreement){
                            var lis1 = data.wageAgreement.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList8.push(obj)
                            }
                        }
                        that.fileList9 = []
                        if(data.ruralWorkers && ''!=data.ruralWorkers){
                            var lis1 = data.ruralWorkers.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList9.push(obj)
                            }
                        }
                        that.fileList10 = []
                        if(data.bidBond && ''!=data.bidBond){
                            var lis1 = data.bidBond.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList10.push(obj)
                            }
                        }
                        that.fileList11 = []
                        if(data.voucher && ''!=data.voucher){
                            var lis1 = data.voucher.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList11.push(obj)
                            }
                        }
                        that.fileList12 = []
                        if(data.disbursementVoucher && ''!=data.disbursementVoucher){
                            var lis1 = data.disbursementVoucher.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList12.push(obj)
                            }
                        }
                        that.fileList13 = []
                        if(data.constructionUnitShal && ''!=data.constructionUnitShal){
                            var lis1 = data.constructionUnitShal.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList13.push(obj)
                            }
                        }
                        that.fileList14 = []
                        if(data.letter && ''!=data.letter){
                            var lis1 = data.letter.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList14.push(obj)
                            }
                        }
                        that.fileList15 = []
                        if(data.rightInformation && ''!=data.rightInformation){
                            var lis1 = data.rightInformation.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList15.push(obj)
                            }
                        }
                        that.fileList16 = []
                        if(data.subcontractorEntrusts && ''!=data.subcontractorEntrusts){
                            var lis1 = data.subcontractorEntrusts.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList16.push(obj)
                            }
                        }
                    }
                }
            })
        },

        //上传1
        fileSuccess1(res, file){
            if(res.code == 200){
                var obj = {}
                obj.uid = file.uid
                obj.url = res.data.saveUrls
                obj.showUrl = base.httpCtx + res.data.saveUrls
                obj.srcList = [base.httpCtx + res.data.saveUrls]
                this.fileList1.push(obj)
            }else{
                this.$message.error(resp.data.msg)
            }
        },
        //上传2
        fileSuccess2(res, file){
            if(res.code == 200){
                var obj = {}
                obj.uid = file.uid
                obj.url = res.data.saveUrls
                obj.showUrl = base.httpCtx + res.data.saveUrls
                obj.srcList = [base.httpCtx + res.data.saveUrls]
                this.fileList2.push(obj)
            }else{
                this.$message.error(resp.data.msg)
            }
        },
        //上传3
        fileSuccess3(res, file){
            if(res.code == 200){
                var obj = {}
                obj.uid = file.uid
                obj.url = res.data.saveUrls
                obj.showUrl = base.httpCtx + res.data.saveUrls
                obj.srcList = [base.httpCtx + res.data.saveUrls]
                this.fileList3.push(obj)
            }else{
                this.$message.error(resp.data.msg)
            }
        },
        //上传4
        fileSuccess4(res, file){
            if(res.code == 200){
                var obj = {}
                obj.uid = file.uid
                obj.url = res.data.saveUrls
                obj.showUrl = base.httpCtx + res.data.saveUrls
                obj.srcList = [base.httpCtx + res.data.saveUrls]
                this.fileList4.push(obj)
            }else{
                this.$message.error(resp.data.msg)
            }
        },
        //上传5
        fileSuccess5(res, file){
            if(res.code == 200){
                var obj = {}
                obj.uid = file.uid
                obj.url = res.data.saveUrls
                obj.showUrl = base.httpCtx + res.data.saveUrls
                obj.srcList = [base.httpCtx + res.data.saveUrls]
                this.fileList5.push(obj)
            }else{
                this.$message.error(resp.data.msg)
            }
        },
        //上传6
        fileSuccess6(res, file){
            if(res.code == 200){
                var obj = {}
                obj.uid = file.uid
                obj.url = res.data.saveUrls
                obj.showUrl = base.httpCtx + res.data.saveUrls
                obj.srcList = [base.httpCtx + res.data.saveUrls]
                this.fileList6.push(obj)
            }else{
                this.$message.error(resp.data.msg)
            }
        },
        //上传7
        fileSuccess7(res, file){
            if(res.code == 200){
                var obj = {}
                obj.uid = file.uid
                obj.url = res.data.saveUrls
                obj.showUrl = base.httpCtx + res.data.saveUrls
                obj.srcList = [base.httpCtx + res.data.saveUrls]
                this.fileList7.push(obj)
            }else{
                this.$message.error(resp.data.msg)
            }
        },
        //上传8
        fileSuccess8(res, file){
            if(res.code == 200){
                var obj = {}
                obj.uid = file.uid
                obj.url = res.data.saveUrls
                obj.showUrl = base.httpCtx + res.data.saveUrls
                obj.srcList = [base.httpCtx + res.data.saveUrls]
                this.fileList8.push(obj)
            }else{
                this.$message.error(resp.data.msg)
            }
        },
        //上传9
        fileSuccess9(res, file){
            if(res.code == 200){
                var obj = {}
                obj.uid = file.uid
                obj.url = res.data.saveUrls
                obj.showUrl = base.httpCtx + res.data.saveUrls
                obj.srcList = [base.httpCtx + res.data.saveUrls]
                this.fileList9.push(obj)
            }else{
                this.$message.error(resp.data.msg)
            }
        },
        //上传10
        fileSuccess10(res, file){
            if(res.code == 200){
                var obj = {}
                obj.uid = file.uid
                obj.url = res.data.saveUrls
                obj.showUrl = base.httpCtx + res.data.saveUrls
                obj.srcList = [base.httpCtx + res.data.saveUrls]
                this.fileList10.push(obj)
            }else{
                this.$message.error(resp.data.msg)
            }
        },
        //上传11
        fileSuccess11(res, file){
            if(res.code == 200){
                var obj = {}
                obj.uid = file.uid
                obj.url = res.data.saveUrls
                obj.showUrl = base.httpCtx + res.data.saveUrls
                obj.srcList = [base.httpCtx + res.data.saveUrls]
                this.fileList11.push(obj)
            }else{
                this.$message.error(resp.data.msg)
            }
        },
        //上传12
        fileSuccess12(res, file){
            if(res.code == 200){
                var obj = {}
                obj.uid = file.uid
                obj.url = res.data.saveUrls
                obj.showUrl = base.httpCtx + res.data.saveUrls
                obj.srcList = [base.httpCtx + res.data.saveUrls]
                this.fileList12.push(obj)
            }else{
                this.$message.error(resp.data.msg)
            }
        },
        //上传13
        fileSuccess13(res, file){
            if(res.code == 200){
                var obj = {}
                obj.uid = file.uid
                obj.url = res.data.saveUrls
                obj.showUrl = base.httpCtx + res.data.saveUrls
                obj.srcList = [base.httpCtx + res.data.saveUrls]
                this.fileList13.push(obj)
            }else{
                this.$message.error(resp.data.msg)
            }
        },
        //上传14
        fileSuccess14(res, file){
            if(res.code == 200){
                var obj = {}
                obj.uid = file.uid
                obj.url = res.data.saveUrls
                obj.showUrl = base.httpCtx + res.data.saveUrls
                obj.srcList = [base.httpCtx + res.data.saveUrls]
                this.fileList14.push(obj)
            }else{
                this.$message.error(resp.data.msg)
            }
        },
        //上传15
        fileSuccess15(res, file){
            if(res.code == 200){
                var obj = {}
                obj.uid = file.uid
                obj.url = res.data.saveUrls
                obj.showUrl = base.httpCtx + res.data.saveUrls
                obj.srcList = [base.httpCtx + res.data.saveUrls]
                this.fileList15.push(obj)
            }else{
                this.$message.error(resp.data.msg)
            }
        },
        //上传16
        fileSuccess16(res, file){
            if(res.code == 200){
                var obj = {}
                obj.uid = file.uid
                obj.url = res.data.saveUrls
                obj.showUrl = base.httpCtx + res.data.saveUrls
                obj.srcList = [base.httpCtx + res.data.saveUrls]
                this.fileList16.push(obj)
            }else{
                this.$message.error(resp.data.msg)
            }
        },
        //提交
        submitForm(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.form.projectId = this.groupId
                    for(var i=0;i<this.fileList1.length;i++){
                        this.form.workersAccount = this.form.workersAccount==''?this.fileList1[i].url:this.form.workersAccount+','+this.fileList1[i].url
                    }
                    for(var j=0;j<this.fileList2.length;j++){
                        this.form.accounting = this.form.accounting==''?this.fileList2[j].url:this.form.accounting+','+this.fileList2[j].url
                    }
                    for(var j=0;j<this.fileList3.length;j++){
                        this.form.wageAudit = this.form.wageAudit==''?this.fileList3[j].url:this.form.wageAudit+','+this.fileList3[j].url
                    }
                    for(var j=0;j<this.fileList4.length;j++){
                        this.form.bankAgreement = this.form.bankAgreement==''?this.fileList4[j].url:this.form.bankAgreement+','+this.fileList4[j].url
                    }
                    for(var j=0;j<this.fileList5.length;j++){
                        this.form.wageWater  = this.form.wageWater ==''?this.fileList5[j].url:this.form.wageWater+','+this.fileList5[j].url
                    }
                    for(var j=0;j<this.fileList6.length;j++){
                        this.form.waterNotice = this.form.waterNotice==''?this.fileList6[j].url:this.form.waterNotice+','+this.fileList6[j].url
                    }
                    for(var j=0;j<this.fileList7.length;j++){
                        this.form.cashDeposit = this.form.cashDeposit==''?this.fileList7[j].url:this.form.cashDeposit+','+this.fileList7[j].url
                    }
                    for(var j=0;j<this.fileList8.length;j++){
                        this.form.wageAgreement = this.form.wageAgreement==''?this.fileList8[j].url:this.form.wageAgreement+','+this.fileList8[j].url
                    }
                    for(var j=0;j<this.fileList9.length;j++){
                        this.form.ruralWorkers = this.form.ruralWorkers==''?this.fileList9[j].url:this.form.ruralWorkers+','+this.fileList9[j].url
                    }
                    for(var j=0;j<this.fileList10.length;j++){
                        this.form.bidBond = this.form.bidBond==''?this.fileList10[j].url:this.form.bidBond+','+this.fileList10[j].url
                    }
                    for(var j=0;j<this.fileList11.length;j++){
                        this.form.voucher = this.form.voucher==''?this.fileList11[j].url:this.form.voucher+','+this.fileList11[j].url
                    }
                    for(var j=0;j<this.fileList12.length;j++){
                        this.form.disbursementVoucher = this.form.disbursementVoucher==''?this.fileList12[j].url:this.form.disbursementVoucher+','+this.fileList12[j].url
                    }
                    for(var j=0;j<this.fileList13.length;j++){
                        this.form.constructionUnitShal = this.form.constructionUnitShal==''?this.fileList13[j].url:this.form.constructionUnitShal+','+this.fileList13[j].url
                    }
                    for(var j=0;j<this.fileList14.length;j++){
                        this.form.letter = this.form.letter==''?this.fileList14[j].url:this.form.letter+','+this.fileList14[j].url
                    }
                    for(var j=0;j<this.fileList15.length;j++){
                        this.form.rightInformation = this.form.rightInformation==''?this.fileList15[j].url:this.form.rightInformation+','+this.fileList15[j].url
                    }
                    for(var j=0;j<this.fileList16.length;j++){
                        this.form.subcontractorEntrusts = this.form.subcontractorEntrusts==''?this.fileList16[j].url:this.form.subcontractorEntrusts+','+this.fileList16[j].url
                    }
                    var that = this
                    //if(this.form.id==''){
                        this.form.createBy = util.session.get('user').id
                        myHttp.createOrUpdateSpecialAccount(this.form).then(function(resp){
                            if (resp.data.code == '200') {
                                that.$message.success('提交成功')
                            } else {
                                that.$message.error(resp.data.msg)
                            }
                        })
                    // }else{
                    //     this.form.updateBy = util.session.get('user').id
                    //     myHttp.createOrUpdateSpecialAccount(this.form).then(function(resp){
                    //         if (resp.data.code == '200') {
                    //             that.$message.success('修改成功')
                    //         } else {
                    //             that.$message.error(resp.data.msg)
                    //         }
                    //     })
                    // }
                } else {
                    return false;
                }
            });
        },
        // handleRemove(file) {
        //     console.log(file);
        // },
        // handlePictureCardPreview(file) {
        //     this.dialogImageUrl = file.url;
        //     this.dialogVisible = true;
        // },
        // handleDownload(file) {
        //     console.log(file);
        // },
        //返回
        goBack(){
            this.$router.go(-1)
        },
    }
}
</script>

<style scoped>
    .join-ent-box{
        width: 100%;
        height: 100%;
        position: relative;
        /* padding: 1vh 5vw; */
        background: #fff;
    }
    .box-head{
        width: 100%;
        height: 5vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        border-bottom: 2px solid #048ff9;
        padding: 0 2vw;
        justify-content: space-between;
    }
    .box-con{
        width: 100%;
        height: calc( 100% - 5vh );
        position: relative;
        padding: 1vh 5vw;
        overflow: auto;
    }
    .contract-photo{
        width: 116px;
        height: 116px;
        position: relative;
        padding:0 16px 16px 0;
    }
</style>

<style>
    .join-ent-box .el-form-item__content{
        text-align: left;
        display: flex;
        flex-wrap: wrap;
    }
    .join-ent-box .el-textarea__inner{
        max-width: 300px;
    }
    .join-ent-box .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .join-ent-box .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .join-ent-box .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
    }
    .join-ent-box .avatar {
        width: 100px;
        height: 100px;
        display: block;
    }
    .join-ent-box .el-form-item__label{
        line-height: 20px;
    }
</style>